import { render, staticRenderFns } from "./rankBarCharts.vue?vue&type=template&id=01a99d1e"
import script from "./rankBarCharts.vue?vue&type=script&lang=js"
export * from "./rankBarCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports